// Opt-in environment isolation. Empty preserves every existing storage key and
// database name; an isolated build never falls back to another environment's
// auth, cached content or private drafts, and never migrates/deletes them.
export const storageNamespace = (process.env.REACT_APP_STORAGE_NAMESPACE || '').trim();
const prefix = storageNamespace ? `wiw:${encodeURIComponent(storageNamespace)}:` : '';
export const storageName = name => `${prefix}${name}`;

const scopedStorage = kind => Object.freeze({
  getItem: key => window[kind].getItem(storageName(key)),
  setItem: (key, value) => window[kind].setItem(storageName(key), value),
  removeItem: key => window[kind].removeItem(storageName(key)),
});

// Keys are logical names throughout the app. HTTP header names in config stay
// unchanged: only the browser's physical storage key gets a namespace.
export const appLocalStorage = scopedStorage('localStorage');
export const appSessionStorage = scopedStorage('sessionStorage');
export const isStorageKey = (event, key) => event.key === null || event.key === storageName(key);

export const languageDetection = storageNamespace ? {
  order: ['querystring', 'localStorage', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: storageName('i18nextLng'),
  lookupSessionStorage: storageName('i18nextLng'),
  lookupCookie: storageName('i18next'),
} : {
  order: ['queryString', 'cookie'],
  cache: ['cookie'],
};
